import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
export const MessagesOpenMailBoxSurvey = ({
  surveyOpenMailBoxMessages,
  setSurveyOpenMailBoxMessages,
}) => {
  const handleChangeMessage = (field, valueOrEvent) => {
    const value =
      typeof valueOrEvent === 'boolean'
        ? valueOrEvent
        : valueOrEvent?.target?.type === 'radio'
        ? valueOrEvent.target.value === 'true'
        : valueOrEvent.target.value;

    setSurveyOpenMailBoxMessages((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div>
      <FormControl
        style={{ marginBottom: '1.5em', marginTop: '1.5em', width: '100%' }}
      >
        <TextField
          id="title"
          label="Tooltip para el campo de ingreso buzón abierto"
          value={surveyOpenMailBoxMessages.inputMessage}
          name="inputMessage"
          fullWidth
          onChange={(event) => handleChangeMessage('inputMessage', event)}
        />
      </FormControl>
      {/*
      <FormControl component="fieldset" style={{ marginBottom: "1.5em" }}>
        <Typography
          variant="subtitle1"
          style={{ marginBottom: "0.5em", fontStyle: "italic" }}
        >
          ¿Quieres que el input para el mailbox sea obligatorio?
        </Typography>
        <RadioGroup
          row
          name="isRequeridMailBoxInput"
          value={surveyOpenMailBoxMessages.isRequeridMailBoxInput?.toString() || "false"}
          onChange={(e) =>
            handleChangeMessage("isRequeridMailBoxInput", e.target.value === "true")
          }
        >
          <FormControlLabel
            value="true"
            control={<Radio />}
            label="Sí. Requerido / Opcional"
          />
          <FormControlLabel
            value="false"
            control={<Radio />}
            label="No. Opcional"
          />
        </RadioGroup>
      </FormControl> */}
    </div>
  );
};
